module.exports = __webpack_public_path__ + "static/buehne_startseite-543055f5b46bd2ed7761c9780e82055a.svg";